import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import Form from "@common/externos/components/validation/form.validation";
import autoBind from "react-autobind";
import { Row, Col } from "react-bootstrap";
import DDadosItem from "@common/components/ddados/ddados.item";
import DDados from '../habitese.ddados';
import habiteseSelectors from '../store/habitese.selectors';
import habiteseActions from '../store/habitese.actions';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "obrasParticulares" });
  }

  handleSetHabitese(value) {
    this.props.habiteseActions.setHabitese(value);
  }

  render() {
    const { Campos } = DDados;
    const { title, onPrintReport, onValidate, onPrint } = this.props;
    const { habitese } = this.props.habiteseSelectors;

    return (
      <Form
        onValidate={!onPrint ? onValidate : null}
        onPrintReport={onPrint ? onPrintReport : null}
        onCancel={this.onCancel}
        boxForm
        prefix={""}
        title={title}
        formControl={true}
      >
        {() => (
          <Fragment>
            <Row>
              <Col lg={3}>
                <DDadosItem
                  name="NumeroProjeto"
                  {...Campos.NumeroProjeto}
                  state={habitese}
                  onBlur={value => this.handleSetHabitese({ NumeroProjeto: value })}
                />
              </Col>
              <Col lg={3}>
                <DDadosItem
                  name="AnoProjeto"
                  {...Campos.AnoProjeto}
                  state={habitese}
                  onBlur={value => this.handleSetHabitese({ AnoProjeto: value })}
                />
              </Col>
              <Col lg={3}>
                <DDadosItem
                  name="NumeroHabitese"
                  {...Campos.NumeroHabitese}
                  state={habitese}
                  onBlur={value => this.handleSetHabitese({ NumeroHabitese: value })}
                />
              </Col>
              <Col lg={3}>
                <DDadosItem
                  name="DataEmissaoHabitese"
                  {...Campos.DataEmissaoHabitese}
                  state={habitese}
                  onChange={value => this.handleSetHabitese({ DataEmissaoHabitese: value })}
                />
              </Col>
            </Row>
          </Fragment>
        )}
      </Form>
    );
  }
}

export default connect({
  selectors: {
    habiteseSelectors,
  },
  actions: {
    habiteseActions,
  },
})(Container);
